import React from "react"
import{Link} from 'react-router-dom'
import dragmain from "../imgs/dragmain.png"

const Draginfo=()=>{
	return(
			<div>
			<div>
			<img src={dragmain} className="dragmain" alt="dragdiag"/>
			<Link to="/animation"><button className="button">Animation</button></Link>
			<div className="liftdiv"><p>
<strong>Drag</strong> is created when a solid body is moved through a fluid (gas or liquid), the fluid resists the motion. The object is subjected to an aerodynamic force in a direction opposed to the motion. This force is called drag.

Drag is the aerodynamic force (that opposes an aircraft's motion through the air) and mechanical force. It is generated by the interaction and contact of a solid body with a fluid (liquid or gas). It is not generated by a force field.

For drag to be generated, the solid body must be in contact with the fluid. If there is no fluid, there is no drag. Drag is generated by the difference in velocity between the solid object and the fluid. There must be motion between the object and the fluid. If there is no motion, there is no drag. It makes no difference whether the object moves through a static fluid or whether the fluid moves past a static solid object. Drag acts in a direction that opposes the motion. </p>


TThere are many factors that affect drag. We can group these factors into:-

 (a) Those associated with the object, (b) Those associated with the motion of the object through the air, and (c) Those associated with the air itself<br/><br/>


a.                  Object: Aircraft geometry has a large effect on the amount of drag generated. Drag depends linearly on the size of the object moving through the air. <br/>


b.     Motion: Drag is associated with the movement of the aircraft through the air, so drag will then depend on the velocity of the air. Drag actually varies with the square of the velocity between the object and the air. How the object is inclined to the flow will also affect the amount of drag generated.<br/>


c.      Air: Drag depends directly on the mass of the flow going past the aircraft. The drag also depends in a complex way on two other properties of the air: its viscosity and its compressibility.<br/>

<br/>
<br/>

<strong>Equation for Drag</strong><br/>
<br/>


Drag depends on the density of the air, the square of the velocity, the air's viscosity and compressibility, the size and shape of the body, and the body's inclination to the flow.<br/>
<br/>


Drag = Cd * A * 0.5 * r * V2<br/>
<br/>
<br/>
<br/>


<strong>Coefficient of Drag</strong><br/>
<br/>


For given air conditions, shape, and inclination of the object, we must determine a value for Cd to determine drag. Determining the value of the drag coefficient is more difficult than determining the lift coefficient because of the multiple sources of drag. The drag coefficient given above includes form drag, skin friction drag, wave drag, and induced drag components.

			</div>
			</div>
			</div>
		);
}

export default Draginfo;